import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { NavLink } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { withRouter } from "../../../withRouter";
import logo from "../../website/home/assets/img/givbeeLogo.png";
import "./VerifyOTP.css";
import FetchServerData from "../../../provider/FetchServerData";
import {
  ResentOTP_Url,
  Static_Url,
  StaticEventText_Url,
} from "../../../provider/ServiceUrl";
import store from "../../../redux/store";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import PtsAlert from "../ptsAlert/PtsAlert";
import CrmIntegrationAction from "../../../redux/crmIntegration/CrmIntegrationAction";
import Utils from "../../../provider/Utils";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";

export class VerifyOTP extends Component {
  header = store.getState().header.header;
  constructor(props) {
    super(props);
    let businessDomain = "";
    let sendOtpByEmail = false;
    let sendOtpByText = false;
    let resendOtpByEmail = false;
    let resendOtpByText = false;
    let rememberMe = false;
    let password = "";
    if (props.state) {
      businessDomain = props.state.businessDomain;
      sendOtpByEmail = props.state.sendOtpByEmail;
      sendOtpByText = props.state.sendOtpByText;
      resendOtpByEmail = props.state.resendOtpByEmail;
      resendOtpByText = props.state.resendOtpByText;
      rememberMe = props.state.rememberMe;
      password = props.state.password;
    }
    this.state = {
      verifyOtp: "",
      value1: "",
      value1Ref: React.createRef(),
      value2: "",
      value2Ref: React.createRef(),
      value3: "",
      value3Ref: React.createRef(),
      value4: "",
      value4Ref: React.createRef(),
      value5: "",
      value5Ref: React.createRef(),
      value6: "",
      value6Ref: React.createRef(),
      businessDomain: businessDomain,
      sendOtpByEmail: sendOtpByEmail,
      sendOtpByText: sendOtpByText,
      resendOtpByEmail: resendOtpByEmail,
      resendOtpByText: resendOtpByText,
      rememberMe: rememberMe,
      password: password,
      error: false,
      render: false,
    };
  }

  componentDidMount() {
    this.state.value1Ref.current.focus();
  }

  handleValueChange = async (e) => {
    const { name, value } = e.target;

    if (e.key === "Backspace") {
      return;
    }
    if (value.length > 1) {
      PtsAlert.error("Please enter one number per box.");
      return;
    }

    await this.setState({ [name]: value });

    switch (name) {
      case "value1":
        this.value2Focus();
        this.value2Select();
        break;
      case "value2":
        this.value3Focus();
        this.value3Select();
        break;
      case "value3":
        this.value4Focus();
        this.value4Select();
        break;
      case "value4":
        this.value5Focus();
        this.value5Select();
        break;
      case "value5":
        this.value6Focus();
        this.value6Select();
        break;
      case "value6":
        this.verifyOTPInBackend();
        break;
      default:
        break;
    }
  };

  handleKeyUp = (e) => {
    const { name, key } = e.target;
    if (key === "Enter") {
      this.verifyOTPInBackend();
    } else if (key === "ArrowLeft") {
      const map = {
        value2: this.value1Ref,
        value3: this.value2Ref,
        value4: this.value3Ref,
        value5: this.value4Ref,
        value6: this.value5Ref,
      };
      if (map[name]) map[name].current.focus();
    } else if (key === "ArrowRight") {
      const map = {
        value1: this.value2Ref,
        value2: this.value3Ref,
        value3: this.value4Ref,
        value4: this.value5Ref,
        value5: this.value6Ref,
      };
      if (map[name]) map[name].current.focus();
    }
  };

  handleKeyDown = (e) => {
    if (e.key !== "Backspace") return;

    e.preventDefault();
    const { name, value } = e.target;

    const prevMap = {
      value2: this.state.value1Ref,
      value3: this.state.value2Ref,
      value4: this.state.value3Ref,
      value5: this.state.value4Ref,
      value6: this.state.value5Ref,
    };

    if (!value) {
      const prev = prevMap[name];
      if (prev?.current) {
        prev.current.focus();
      }
      return;
    }

    this.setState({ [name]: "" });
  };

  value1Focus = () => {
    this.state.value1Ref.current.focus();
  };
  value2Focus = () => {
    this.state.value2Ref.current.focus();
  };
  value3Focus = () => {
    this.state.value3Ref.current.focus();
  };
  value4Focus = () => {
    this.state.value4Ref.current.focus();
  };
  value5Focus = () => {
    this.state.value5Ref.current.focus();
  };
  value6Focus = () => {
    this.state.value6Ref.current.focus();
  };

  value1Select = () => {
    this.state.value1Ref.current.select();
  };
  value2Select = () => {
    this.state.value2Ref.current.select();
  };
  value3Select = () => {
    this.state.value3Ref.current.select();
  };
  value4Select = () => {
    this.state.value4Ref.current.select();
  };
  value5Select = () => {
    this.state.value5Ref.current.select();
  };
  value6Select = () => {
    this.state.value6Ref.current.select();
  };

  renderInputBox = (name, ref) => {
    return (
      <Col md={2} style={{ padding: "0rem 1rem 0rem 0rem" }}>
        <input
          type="number"
          ref={this.state[ref]}
          className="form-control otpFormControlInput"
          id={"otpFormControlInput-" + name}
          maxLength="1"
          name={name}
          value={this.state[name]}
          onKeyUp={this.handleKeyUp}
          onKeyDown={this.handleKeyDown}
          onChange={this.handleValueChange}
          aria-describedby="defaultFormControlHelp"
        />
      </Col>
    );
  };

  verifyOTPInBackend() {
    const { value1, value2, value3, value4, value5, value6 } = this.state;

    const otpValue = `${value1}${value2}${value3}${value4}${value5}${value6}`;

    if (otpValue.length !== 6) {
      return;
    }
    const postObject = {
      header: this.header,
      otp: otpValue,
    };
    FetchServerData.callPostService("/appuserms/verifyOtp", postObject).then(
      (response) => {
        if (response.status === "SUCCESS") {
          let output = response.data;
          let appuser = output.appuser;
          this.processLoginSuccess(output);
          const browserName = Utils.getBrowserType();
          if (appuser.isRememberMe) {
            // localStorage.setItem("userId", appuser.email);
            // localStorage.setItem("password", this.state.password);
            // localStorage.setItem(
            //   "selectedOption",
            //   JSON.stringify(appuser.tenant)
            // );
            localStorage.setItem("rememberMe", appuser.isRememberMe);
            localStorage.setItem("browserType", browserName);
            localStorage.setItem("header", JSON.stringify(output.header));
          }
        } else {
          if (
            response.message &&
            response.message.includes("Your account is locked")
          ) {
            this.props.navigate("/signin");
          } else {
          }
        }
      }
    );
  }

  processLoginSuccess(output_data) {
    store.dispatch(AppUserDataAction.setUserData(output_data));
    store.dispatch(AppUserDataAction.setUsage(output_data.smsCredits));
    store.dispatch(AppUserDataAction.setTollfreeNumber(output_data.tollfreeNumber));
    store.dispatch(AppUserDataAction.setTollfreeNumberStatus(output_data.tollFreeNumberStatus));
    store.dispatch(
      CrmIntegrationAction.setCrmIntegration(output_data.crmIntegration)
    );
    store.dispatch(
      AppUserDataAction.setOrganization(output_data.appuser?.organization)
    );
    let accountSetting = output_data?.accountSetting;
    store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));
    store.dispatch(
      AppUserDataAction.setTollfreeNumberPurchased(
        output_data?.isTollfreeNumberPurchased
      )
    );
    store.dispatch(
      AppUserDataAction.setCardExpired(output_data?.isCardExpired)
    );
    let orgLogoDocument = output_data.appuser?.organization?.orgLogoDocument;
    let logoData = {
      logo: orgLogoDocument?.url ? orgLogoDocument?.url : "",
      logoFilename: orgLogoDocument?.filename ? orgLogoDocument?.filename : "",
      logoFileextension: orgLogoDocument?.fileext
        ? orgLogoDocument?.fileext
        : "",
    };
    store.dispatch(AppUserDataAction.setLogo(logoData));
    store.dispatch(SelectedTabAction.setSelectedTab(0));

    // if (output_data.isTollfreeNumberPurchased === true) {
    //   store.dispatch(SelectedTabAction.setSelectedTab(0));
    // } else {
    //   store.dispatch(SelectedTabAction.setSelectedTab(1));
    //   if (output_data.cmpaigningInfoError) {
    //   }
    // }

    let header = this.header;
    this.loadDashboardPage(header, output_data);
  }
  async loadDashboardPage(header, output) {
    let menus = output.appuser?.profile?.menus.sort(
      (a, b) => a.displaysequence - b.displaysequence
    );
    await this.setStaticData(header);
    store.dispatch(
      ActiveMenuAction.setActiveMenu(Utils.getArrayElement(menus, 0)?.pageid)
    );

    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      if (menu.isactive) {
        this.props.navigate(menu.pageid);
        break;
      }
    }
  }

  async setStaticData(header) {
    let StaticUrl = Utils.equalsIgnoreCase(
      this.state.businessDomain,
      BUSINESS_DOMAIN.eventText
    )
      ? StaticEventText_Url
      : Static_Url;
    const postObject = {
      header: header,
    };

    FetchServerData.callPostService(StaticUrl, postObject).then((output) => {
      if (output.status === "SUCCESS") {
        store.dispatch(staticDataAction.setStaticData(output.data));
      } else {
      }
    });
  }

  ResendVerifyOTP() {
    if (!this.state.resendOtpByEmail && !this.state.resendOtpByText) {
      this.setState({
        error: true,
      });
      return;
    }
    const postObject = {
      header: this.header,
      appuser: {
        sendOtpByEmail: this.state.resendOtpByEmail,
        sendOtpByText: this.state.resendOtpByText,
      },
    };
    FetchServerData.callPostService(ResentOTP_Url, postObject).then(
      (response) => {
        if (response.status === "SUCCESS") {
          PtsAlert.success(response.message);
          this.state.value1Ref.current.focus();
          this.setState({
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            value5: "",
            value6: "",
          });
        } else {
        }
      }
    );
  }

  handleResendOtpByEmailChange(e) {
    this.setState({ resendOtpByEmail: e.target.checked, error: false });
  }
  handleResendOtpByTextChange(e) {
    this.setState({ resendOtpByText: e.target.checked, error: false });
  }

  renderOtpSentMessage() {
    const { sendOtpByEmail, sendOtpByText } = this.state;
    if (sendOtpByEmail && sendOtpByText) {
      return <p>A verification code has been sent to your mobile and email.</p>;
    } else if (sendOtpByEmail) {
      return <p>A verification code has been sent to your email.</p>;
    } else if (sendOtpByText) {
      return <p>A verification code has been sent to your mobile.</p>;
    }
    return null;
  }

  render() {
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          <div
            className="d-flex col-12 col-lg-6 col-xl-6 align-items-center leftBackground"
            style={{ textAlign: "center", background: "rgb(55, 81, 126)" }}
          >
            <div className="mx-auto">
              <div className="logoBackground">
                <img
                  src={logo}
                  className="img-fluid logoImage"
                  alt=""
                  data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                  data-app-light-img="illustrations/girl-with-laptop-light.png"
                />
              </div>
            </div>
          </div>
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              <ValidatorForm
                className="text-start"
                ref="form"
                onSubmit={this.verifyOTPInBackend.bind(this)}
              >
                <div className="signinHeding">Account Verification</div>
                <div className="mb-2 mt-2">
                  {this.renderOtpSentMessage()}
                  <label className="form-label" htmlFor="multiStepsPass">
                    Enter Verification Code
                  </label>
                  <Row style={{ margin: "0.6em 0em" }}>
                    {this.renderInputBox("value1", "value1Ref")}
                    {this.renderInputBox("value2", "value2Ref")}
                    {this.renderInputBox("value3", "value3Ref")}
                    {this.renderInputBox("value4", "value4Ref")}
                    {this.renderInputBox("value5", "value5Ref")}
                    {this.renderInputBox("value6", "value6Ref")}
                  </Row>
                </div>
                <div
                  className="row d-flex justify-content-end"
                  style={{ padding: "0px 16px 0px 10px" }}
                >
                  <div class="col-md-6 align-self-center text-start ps-0">
                    <NavLink className="pt-1" to="/signin">
                      <ArrowBackIosNewIcon />
                      Back
                    </NavLink>
                  </div>
                  <div className="col-md-6 text-end align-self-center">
                    <NavLink
                      className="naveLink"
                      onClick={this.ResendVerifyOTP.bind(this)}
                      style={{ float: "right" }}
                    >
                      <span>Resend Code</span>
                    </NavLink>
                  </div>
                </div>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(VerifyOTP);
